
const API_BASE_URL = 'https://codemine-api-worker.shazim-rv11-675.workers.dev';

export const callApi = async (endpoint: string, options: RequestInit = {}) => {
    // Construct the full URL to point to the dedicated API worker.
    const url = `${API_BASE_URL}${endpoint}`;

    const response = await fetch(url, {
        ...options,
        headers: {
            'Content-Type': 'application/json', // Default content type for requests
            ...options.headers,
        },
    });

    const responseText = await response.text();

    if (!response.ok) {
        let errorData;
        try {
            // Try to parse the error response as JSON, as our API often returns JSON errors.
            errorData = JSON.parse(responseText);
            throw new Error(errorData.error || errorData.message || `API Error: ${response.status}`);
        } catch (e) {
            // If the error response is not JSON, throw the raw text.
            const preview = responseText.substring(0, 200).replace(/\n/g, ' ');
            throw new Error(`API Error: ${response.status} - ${preview}`);
        }
    }
    
    // Handle successful but empty responses (e.g., 204 No Content)
    if (!responseText) {
        return null;
    }

    const contentType = response.headers.get('content-type');
    
    // If the server indicates a JSON response, parse it.
    if (contentType && contentType.includes('application/json')) {
        try {
            return JSON.parse(responseText);
        } catch (e) {
            // This is a server-side error: it promised JSON but sent invalid JSON.
            throw new Error("Server sent an invalid JSON response.");
        }
    }
    
    // Otherwise, return the response as plain text.
    return responseText;
};